import React from 'react'
import { Heading } from '../../util/typography'
import IndicationsList from './IndicationsList'
import QSubIndicationList from './QSubIndicationList'

const Indications = ({ indicationId }) => {
    return (
        <>
            <section>
                {/* <header>
                    <Heading.H4 as='h2'>For KEYTRUDA (pembrolizumab)</Heading.H4>
                </header> */}
                <div>
                    <IndicationsList columns={2} indicationId={indicationId} />
                </div>
            </section>
            {/* <section>
                <header>
                    <Heading.H4 as='h2'>For KEYTRUDA QSub (pembrolizumab and berahyaluronidase alfa-xxxx)</Heading.H4>
                </header>
                <div>
                    <QSubIndicationList />
                </div>
            </section> */}

        </>
    )
}

export default Indications;
